import { BoxProps, Flex } from '@chakra-ui/react';
import ContentCardSkeleton from './ContentCardSkeleton';

// A wrapping grid of card skeletons matching the content feed / dashboard layout.
const ContentCardSkeletonGrid = ({
  count = 6,
  justify = 'flex-start',
  cardSize,
}: {
  count?: number;
  justify?: 'flex-start' | 'center';
  cardSize?: BoxProps['width'];
}) => (
  <Flex width="100%" gap="16px" wrap="wrap" justify={justify}>
    {Array.from({ length: count }).map((_, index) => (
      <ContentCardSkeleton key={index} size={cardSize} />
    ))}
  </Flex>
);

export default ContentCardSkeletonGrid;
